import { render, staticRenderFns } from "./LatestNoticeList.vue?vue&type=template&id=61199e18&"
import script from "./LatestNoticeList.vue?vue&type=script&lang=js&"
export * from "./LatestNoticeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports